/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
export class MeetingParticipantEntity extends Entity {
  attendeeName: string | null = null;
  createdAt: string | null = null;
  id: string = '';
  joinedAt: string | null = null;
  leftAt: string | null = null;
  updatedAt: string | null = null;
  zoomId: string | null = null;
  static override key = 'MeetingParticipant';
  static override schema = {};
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'MeetingParticipant' in input
    ) {
      const { MeetingParticipant: wrapped, ...rest } = input as {
        MeetingParticipant: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}